import React from 'react';

interface EmployeeCardImageProps {
  name: string;
  photoUrl?: string;
  className?: string;
}

/**
 * EmployeeCardImage renders a full-width hero image for employee grid cards
 * with an onError fallback to initials when the image fails to load.
 */
export function EmployeeCardImage({ name, photoUrl, className }: EmployeeCardImageProps) {
  const [imageError, setImageError] = React.useState(false);

  const getInitials = (fullName: string): string => {
    const parts = fullName.trim().split(' ');
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  if (photoUrl && !imageError) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={className}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/20 to-primary/5">
      <span className="text-5xl font-bold text-primary/40">
        {getInitials(name)}
      </span>
    </div>
  );
}
